var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11642 2.2423C6.52793 1.83079 7.08606 1.59961 7.66802 1.59961C8.24998 1.59961 8.8081 1.83079 9.21961 2.2423C9.63112 2.65381 9.8623 3.21193 9.8623 3.7939V5.99961M2.59922 7.45104C2.77644 8.66871 3.38614 9.78187 4.31678 10.5869C5.24743 11.3919 6.43679 11.8349 7.66729 11.8349M7.66729 11.8349C8.89778 11.8349 10.0871 11.3919 11.0178 10.5869C11.9484 9.78187 12.5581 8.66871 12.7354 7.45104M7.66729 11.8349V14.3996M5.47373 5.19961V6.71961C5.47373 7.30157 5.70492 7.8597 6.11642 8.2712C6.52793 8.68271 7.08606 8.91389 7.66802 8.91389C8.04036 8.91389 8.40294 8.81926 8.7236 8.64332M2.19922 1.59961L13.7992 13.1996",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMicrophone);
export default __webpack_public_path__ + "static/media/no-microphone.3ebf374d74d3089ae808965a529fced2.svg";
export { ForwardRef as ReactComponent };